import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import MarketWbApi from '../../../API/market/wb-api';
import SuppliesApi from '../../../API/shipment/supplies-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { Input } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { Text } from '../../../components/Basic/WrapsStyle';
import {
  MARKETS_ALL,
  MARKETS_MAP
} from '../../../constans';
import { getDate } from '../../../utils';
import styles from './styles.module.scss';
import SupplyItemLine from './SupplyItemLine';


export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим коробов', 'Режим статистики', 'Режим по дням'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '120px', // 14
  '90px', // 15
];

const SORT_TYPE = [
  { name: 'Не выбран', value: undefined },
  { name: 'По выручке', value: 'earn' },
  { name: 'По убытку', value: 'lost' },
  { name: 'По кол-ву продаж', value: 'sale_count' },
  { name: 'По сумме хранения', value: 'storage_sum' },

];

const NAVIGATE = {
  'Режим коробов': ['Товары',],
  'Режим статистики': ['Товары', 'Продано', 'Частично продано', 'Доставляется', 'Не продавалось', 'Отмены', 'Возвраты пвз'],
  'Режим по дням': [],
};

const FILTER = {
  'Режим коробов': {
    0: 'products',
  },
  'Режим статистики': {
    0: 'products_grouped',
    1: 'products_grouped_all_sold',
    2: 'products_grouped_partly',
    3: 'products_grouped_delivery',
    4: 'products_grouped_not_sold',
    5: 'products_grouped_cancels',
    6: 'products_grouped_return_pvz'
  },
  'Режим по дням': {
    0: 'days_grouped',
  }
};

let abortController = new AbortController();

function SuppliesStatisticPage({ }) {
  let location = useLocation();
  const { id } = useParams();

  const user = useSelector((store) => store.user);

  const [mode, setMode] = useState(MODES[2]);

  const [tab, setTab] = useState(0);
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(25);
  const [countStock, setCountStock] = useState([0]);

  const [supply, setSupply] = useState({ market: '', shop: '', time_scheduled: '' });
  const [supplies, setSupplies] = useState({ market: '', shop: '', time_scheduled: '' });
  const [market, setMarket] = useState('');
  const [shop, setShop] = useState('');

  const [supplyItems, setSupplyItems] = useState({ ids: [], byIds: {}, map: {} });


  const [search, setSearch] = useState(location.state?.posting_number || '');
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const [activeBox, setActiveBox] = useState(null);
  const [boxFilter, setBoxFilter] = useState('Не выбран');
  const [notDebited, setNotDebited] = useState(false);
  const [orderDt, setOrderDt] = useState(null);
  const [sortType, setSortType] = useState(SORT_TYPE[0]);

  const [pricesMode, setPricesMode] = useState(false);
  const [openChzn, setOpenChzn] = useState({ product: null, posting: null, open: false });
  const [chzn, setChzn] = useState('Не выбран');


  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };
  const [inputRef, setInputFocus] = useFocus();



  const [providers, setProviders] = useState([]);
  const [providersIdInShipment, setProvidersIdInShipment] = useState([]);
  const allProviders = useSelector((store) => store.providers);

  const [profitStatistic, setProfitStatistic] = useState({});
  const [storageStatistic, setStorageStatistic] = useState({});


  const onChangePage = (v) => { setPage(v) }
  const onChangeTab = (n) => { setTab(n) }


  const params_days = useMemo(() => {
    return {
      supplyIds: id?.split('&').map(id => +id),
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[mode][tab],
      sortType: sortType.value,
      shop,
      filters: {
        orderDt
      },
    };
  }, [
    id,
    show,
    orderDt,
    mode,
    sortType,
    page,
    search,
    tab,
    provider.id,
  ]);

  const getByDateStat = (date) => {
    setOrderDt(date)
    setMode(MODES[1])
  }


  const loadDays = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();
    SuppliesApi.getSupplyItemsDays({ data: params_days, signal: abortController.signal })
      .then((res) => {
        const { supplyItems, supplies, count, tabs } = res;
        setSupply(res.supplies[0]);
        setSupplies(res.supplies);
        // setCountStock(Object.values(tabs));

        const byIds = {};
        const ids = supplyItems.map((item) => item._id);
        supplyItems.forEach((item) => (byIds[item._id] = item));
        setSupplyItems({ byIds, ids });
        setProvidersIdInShipment(res.providersIdsInShipments);
        setProfitStatistic(res.profitStatistic)
        setStorageStatistic(res.storageStatistic)
        setCount(count);
        setShop(MARKETS_ALL[supplies[0].market][0]);
      })
  };


  useEffect(() => {
    loadDays();
  }, [params_days, mode]);

  const loadPage = async () => {
    loadDays();
  }

  const changeProductsInSupply = async ({ action, supplyId, offerId, quantity, id, value }) => {
    await SuppliesApi.changeProductsInSupply({ data: { supplyId, action, offerId, quantity, shop: MARKETS_MAP[shop], id, value: value === 'Нет' ? null : value, activeBox } })
    await loadData()
  }


  const onChangeCard = async (offer_id, shop, key, value) => {

    if (key === 'price' || key === 'discount') {
      await MarketWbApi.changePrice({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) } })
    }
    if (key === 'percent' || key === 'min_rub') {
      await MarketWbApi.changeMarginality({ data: { shop, offer_id, field: key, value: parseInt(value) } })
    } else {
      await MarketWbApi.changeCard({ data: { shop, offer_id, field: key, value } })
    }

    await loadPage()
  }

  useEffect(() => {
    const p = allProviders.filter((item) => providersIdInShipment?.includes(item.id));
    setProviders([{ name: 'Не выбран', id: null }, ...p] || allProviders);
  }, [allProviders, providersIdInShipment]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  const tab_name = `Поставка: ${supply.market || ''} ${supply.time_scheduled ? getDate(supply.time_scheduled) : ''}`;

  return (
    <>
      <PageTitle title={tab_name || ''} />
      <Content>
        {/* <H1 style={{ marginBottom: '-3px' }}>
          {`Поставка: ${supply.market || ''}  ${supply.time_scheduled ? getDate(supply.time_scheduled) : ''} ${MAP_SKLAD[supply.sklad]}`}
        </H1>
        <LinkBlue to={'/shipment/supplies'} style={{ marginBottom: '10px' }}>
          Вернуться к поставкам
        </LinkBlue> */}

        <div style={{ display: 'inline-flex', width: '100%' }}>

          <Column style={{ width: '1400px', flexGrow: '1', flexBasis: '0' }}>

            <WhiteBlock className={styles.search_block}>
              <>
                <Row className={styles.row_input}>
                  <Input
                    value={search}
                    ref={inputRef}
                    onBlur={(v) => setSearch(v)}
                    onClickEnter={(v) => setSearch(v)}
                    label="Поиск"
                  />
                </Row>
                <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
              </>

            </WhiteBlock>

            <Table styles={styles.table}>
              {/* {mode === MODES[1] && (
                <>
                  <TableHeader whiteHeader>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Итоговая прибыль по отчету: </TextGrey>
                      <Text fontSize={'19px'} style={{ color: profitStatistic?.total_profit_by_report > 0 ? '#01800eca' : '#6e0000d9' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_profit_by_report))} руб. ({numberWithSpaces(Math.ceil(profitStatistic?.total_profit))} руб.) - {numberWithSpaces(Math.ceil(profitStatistic?.total_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Продажи по отчету: </TextGrey>
                      <Text style={{ color: '#01800eab' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.sold_profit_by_report))} руб. ({numberWithSpaces(Math.ceil(profitStatistic?.sold_profit))} руб.) - {numberWithSpaces(Math.ceil(profitStatistic?.sold_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Реализованная закупка: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_purchase_by_report))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Процент выкупа: </TextGrey>
                      <Text fontSize={'20px'} style={{ color: colorByPercent(profitStatistic?.sold_count_by_report * 100 / profitStatistic?.total_count_by_report) }} className={cn(styles.profit)}>
                        {+(profitStatistic?.sold_count_by_report * 100 / profitStatistic?.total_count_by_report).toFixed(2) || '-'} %
                      </Text>
                    </Row>

                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Маржинальность: </TextGrey>
                      <Text fontSize={'20px'} style={{ color: '#838f01ad' }} className={cn(styles.profit)}>
                        {+(profitStatistic?.total_profit_by_report * 100 / profitStatistic?.total_purchase_by_report).toFixed(2) || '-'} %
                      </Text>
                    </Row>
                  </TableHeader>
                  <TableHeader whiteHeader>

                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Отмены по отчету: </TextGrey>
                      <Text style={{ color: '#6e0000bd' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit_by_report))} руб. ({numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit))} руб.) - {numberWithSpaces(Math.ceil(profitStatistic?.cancel_count_by_report))} заказов</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Закупка бракованого товара: </TextGrey>
                      <Text style={{ color: '#6e0000bd' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(profitStatistic?.cancel_return_pvz_purchase_by_report))} руб.</Text>
                    </Row>

                  </TableHeader>
                  <TableHeader whiteHeader>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Хранение всего: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage))} руб.</Text>
                    </Row>
                    <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Хранение сегодня: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage_today))} руб.</Text>
                    </Row>
                  </TableHeader>
                </>
              )} */}
              <TableHeader whiteHeader>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText>Дата</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText>Количество заказов</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText>Продано</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText>Отменено</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText>Выручка</HeaderTitle>

              </TableHeader>
              {supplyItems.ids.map((supplyItemId) => {
                return (
                  <SupplyItemLine
                    pricesMode={pricesMode}
                    boxes={supply.boxes}
                    MODES={MODES}
                    mode={mode}
                    product={supplyItems.byIds[supplyItemId]}
                    card={supplyItems.map?.[supplyItems.byIds[supplyItemId]?.offer_id]}
                    key={supplyItems.byIds[supplyItemId]._id}
                    changeProductsInSupply={changeProductsInSupply}
                    onChangeCard={onChangeCard}
                    getByDateStat={getByDateStat}
                  />
                );
              })}
            </Table>

            <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />

          </Column>
        </div>

      </Content >
    </>
  );
}

export default SuppliesStatisticPage;